/**
 * fix-soldout.js
 * Corrige la lógica de disponibilidad en la zona de compra:
 * - Si el producto tiene al menos una variante disponible, el botón refleja
 *   el estado de la variante seleccionada, no del producto completo.
 * - "Agotado" en el botón solo aparece si la variante seleccionada está agotada.
 * - Si TODAS las variantes están agotadas, el comportamiento original se mantiene.
 * - Actualiza data-product-available en el DOM para sincronizar apps externas (Sticky Cart).
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('variant-selects').forEach((selects) => {
    const productAvailable = selects.dataset.productAvailable === 'true';

    // Si el producto está completamente agotado, no intervenir
    if (!productAvailable) return;

    const section = selects.closest('[id^="shopify-section"]') || document.querySelector('.product');
    const productForm = section?.querySelector('product-form');
    const submitButton = productForm?.querySelector('[type="submit"]');
    const submitText = submitButton?.querySelector('span:first-child');

    if (!submitButton || !submitText) return;

    const updateButton = () => {
      const variantJSON = selects.querySelector('[data-selected-variant]');
      if (!variantJSON) return;

      let variant;
      try {
        variant = JSON.parse(variantJSON.textContent);
      } catch (e) {
        return;
      }

      if (!variant) return;

      const available = variant.available;

      if (available) {
        submitButton.removeAttribute('disabled');
        submitText.textContent = window.variantStrings?.addToCart || 'Agregar al carrito';
      } else {
        submitButton.setAttribute('disabled', 'disabled');
        submitText.textContent = window.variantStrings?.soldOut || 'Agotado';
      }

      // ── NUEVO: sincronizar data-product-available para apps externas ──
      selects.dataset.productAvailable = available;
      if (productForm) productForm.dataset.productAvailable = available;

      // Disparar evento personalizado para que el Sticky Cart pueda escucharlo
      selects.dispatchEvent(new CustomEvent('variant:availability-updated', {
        bubbles: true,
        detail: { available, variantId: variant.id }
      }));
    };

    selects.addEventListener('change', updateButton);
    selects.addEventListener('variant-selects:after-update', updateButton);
    setTimeout(updateButton, 100);
  });
});

